import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import cflService from '../service/cfl-service';
import FormCursoDos from '../components/FormCursoDos';
import Swal from 'sweetalert2';
import { Container, Row, Col } from 'react-bootstrap';

const ActualizarCurso = () => {
  const { id } = useParams();
  const [initialValues, setInitialValues] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    cflService.buscarCursoPorId(id)
      .then(resp => {
        const curso = resp.data.data;
        // Ajustá las fechas al formato YYYY-MM-DD para Formik
        curso.fechaInicio = curso.fechaInicio?.slice(0,10);
        curso.fechaFinalizacion = curso.fechaFinalizacion?.slice(0,10);
        setInitialValues(curso);
      })
      .catch(() => {
        Swal.fire('Error', 'No se pudo cargar el curso', 'error');
        navigate('/cursos');
      });
  }, [id, navigate]);

  const handleUpdate = (values) => {
    
    const fechaPublicacion = (() => {
        const date = new Date();
        date.setMonth(date.getMonth() - 3); // Resta 3 meses
        return date.toISOString().split("T")[0];
    })();

    const anioActual = new Date().getFullYear();

    function normalizeDate(dateStr) {
        if (!dateStr) return ""; 
        const fixed = dateStr.replace(/\//g, '-');
        const d = new Date(fixed);
        if (isNaN(d.getTime())) return ""; 
        return d.toISOString().split('T')[0];
    }
    const data = {
      ...values,
      idCurso: parseInt(values.idCurso),
      nombre: values.nombre,
        nroCurso: parseInt(values.nroCurso),
        horasCatedra: parseInt(values.horasCatedra),
        horasReloj: parseInt(values.horasReloj),
        codigo: values.codigo,
        cupo: values.cupo,
        fechaPublicacion: fechaPublicacion,
        anio: anioActual,
        fechaFinalizacion: normalizeDate(values.fechaFinalizacion),
        fechaInicio: normalizeDate(values.fechaInicio),
        disponibilidad: parseInt(values.cupo),
        visible: 0,
        familiaIdFamilia: parseInt(values.familiaIdFamilia),
        instructorIdInstructor: parseInt(values.instructorIdInstructor),
        sedeIdSede: 1,
        tipo_id_tipo: parseInt(values.tipo_id_tipo),
      };
      console.log("DATA PARA UPDATE:", data);
    // Lógica para actualizar curso
    cflService.actualizarCurso( data)
      .then(resp => {
        if (resp.data.success) {
          Swal.fire('Éxito', 'Curso actualizado correctamente', 'success')
            .then(() => {navigate('/cursos');window.location.reload()});
        } else {
          Swal.fire('Error', 'No se pudo actualizar el curso', 'error');
        }
      })
      .catch(() => {
        Swal.fire('Error', 'Error en la conexión', 'error');
      });
  };

  if (!initialValues) return <div>Cargando...</div>;

  return (
    <Container fluid className='mb-4' style={{ width: '100% !important' }} >
      <Container fluid>
        <Row className="bg-dark  rounded-top-4 align-items-end pt-2 mt-3">
            <Col md={6}>
                <h2 className="text-white" style={{fontVariant:'all-small-caps'}}>Formulario</h2>
            </Col>
            <Col md={6}>
                <h4 className="text-white text-end align-middle" style={{fontWeight:'bold'}}>Editar Curso</h4>
            </Col>
        </Row>
        <Row className=" align-middle border border-dark">
            <h5 className="text-dark text-center align-middle" style={{fontWeight:'bold', fontVariant: 'all-petite-caps'}}>Ingresar datos</h5>
        </Row>
      </Container>
      <FormCursoDos
        initialValues={initialValues}
        onSubmit={handleUpdate}  // Le pasamos el submit para update
        isEditing={true}         // Prop opcional para ajustar UI si querés
      />
    </Container>
  );
};

export default ActualizarCurso;
